// extracted by mini-css-extract-plugin
export default {"label":"reviewChecklist_label__fS2pE","labelCol":"reviewChecklist_labelCol__SmMjc"};